module.exports = __webpack_public_path__ + "img/pic3.fae9a2ce.png";